import { motion } from "framer-motion";
import { Link } from "wouter";
import { certificates } from '../../../db';

export default function CertificatesCarousel() {
  // Filter only visible certificates and sort by issue date (latest first)
  const visibleCertificates = certificates
    .filter(cert => cert.isVisible && cert.logoPath)
    .sort((a, b) => new Date(b.issueDate).getTime() - new Date(a.issueDate).getTime());

  if (visibleCertificates.length === 0) {
    return null;
  }

  return (
    <motion.section
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="mb-16"
    >
      <div className="w-full max-w-7xl mx-auto px-4">
        <div className="flex justify-center items-center gap-8">
          {visibleCertificates.map((certificate, index) => (
            <motion.div
              key={certificate.id}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex-shrink-0"
            >
              <Link to={`/certificate/${certificate.id}`}>
                <div className="cursor-pointer transition-all duration-300 hover:scale-110 hover:opacity-80">
                  <img
                    src={certificate.logoPath}
                    alt={`${certificate.title} certificate`}
                    className="h-24 w-auto object-contain"
                  />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
